import { Icon } from '@/components/Icon';
import { defineComponent } from '@vue/composition-api';
import { mdiAlertOctagonOutline } from '@mdi/js';
export default defineComponent({
    components: { Icon },
    setup() {
        return { mdiAlertOctagonOutline };
    },
});
